import { render, staticRenderFns } from "./DeleteFLayout.vue?vue&type=template&id=3d436ef6"
import script from "./DeleteFLayout.vue?vue&type=script&lang=js"
export * from "./DeleteFLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports